import {formatAmountInDollar, getCurrentLocale} from "../common/util";

$(() => {
    // Animation of the money of a user hold with his points
    $('.count-money').each(function () {
        $(this).prop('counter', 0).animate({
            counter: $(this).text()
        }, {
            duration: 2000,
            easing: 'easeOutExpo',
            step: function (step) {
                $(this).text(formatAmountInDollar(step));
            }
        });
    });

// Animation of the points of a user
    $('.count').each(function () {
        $(this).prop('counter', 0).animate({
            counter: $(this).text()
        }, {
            duration: 2000,
            easing: 'easeOutExpo',
            step: function (step) {
                $(this).text('' + new Intl.NumberFormat(getCurrentLocale(), {maximumFractionDigits: 0}).format(step));
            }
        });
    });

// Animation of the circle appearing in the dashboard on page load
    let textColor = '#FF3000';
    for (let i = 0; i < 29; i++) {
        setTimeout(() => {
            $("#cercle" + i).attr('fill', textColor);
        }, i * 55);
    }
});